<template>
  <main-window-container>
        <main-center-container>
          <main-section-container>
            <main-section-row>
                    <sign-in-header-block></sign-in-header-block>
                </main-section-row>
            <main-section-row>
              <sign-in-fields-block />
            </main-section-row>
          </main-section-container>
        </main-center-container>
  </main-window-container>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import MainWindowContainer from '@/components/containers/MainWindowContainer.vue'
import MainCenterContainer from '@/components/containers/MainCenterContainer.vue'
import MainSectionContainer from '@/components/containers/MainSectionContainer.vue'
import SignInFieldsBlock from '@/components/blocks/SignIn/SignInFieldsBlock.vue'
import MainSectionRow from '@/components/containers/MainSectionRow.vue'
import SignInHeaderBlock from '@/components/blocks/SignIn/SignInHeaderBlock.vue'



export default {
  name: 'HomeView',
  components: {
    HelloWorld, MainWindowContainer, MainCenterContainer, MainSectionContainer, SignInFieldsBlock, MainSectionRow,
    SignInHeaderBlock 
  }
}
</script>
    